 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import E9780806537191_COV01 from '@/components/e9780806537191_cov01'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDLOVE_1 from '@/components/Backed/love_1'
 import E9780806537191_TP01 from '@/components/e9780806537191_tp01'
 import E9780806537191_C01 from '@/components/e9780806537191_c01'
 import BACKEDLOVE_2 from '@/components/Backed/love_2'
 import E9780806537191_BM01 from '@/components/e9780806537191_bm01'
 import E9780806537191_COP01 from '@/components/e9780806537191_cop01'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import ENDMATTER_1 from '@/components/endmatter_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9780806537191_cov01",
 			"name" : "e9780806537191_cov01",
 			"component" : E9780806537191_COV01
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/Backed/love_1",
 			"name" : "Backed/love_1",
 			"component" : BACKEDLOVE_1
 		},
 		{
 			"path" : "/e9780806537191_tp01",
 			"name" : "e9780806537191_tp01",
 			"component" : E9780806537191_TP01
 		},
 		{
 			"path" : "/e9780806537191_c01",
 			"name" : "e9780806537191_c01",
 			"component" : E9780806537191_C01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js